import { add } from "date-fns";

export const globalpermissions = {
  homePage: {
    organisationsListView: 'can_view_organisation_list',
    organisationDetailsView: 'can_view_organisation_details',
    accountListView: 'can_view_account_list',
    addNewAccount: 'can_add_new_account',
    createNewProposal: 'can_create_new_proposal',
    proposalListView: 'can_view_proposal_list',
    campaignStateButtonView: 'can_view_campaign_state_button_on_homepage',
    mapOrGridViewButton: 'can_view_map_or_gridview_button_on_homepage',
    uploadProposalButton: 'can_upload_proposal_from_homepage',
    viewImagesButton: 'can_view_images_of_campaigns_from_homepage',
  },

  proposalSummaryPage: {
    addInvoiceDetails: 'can_add_invoice_details',
  },

  mapviewPage: {
    changeRadius: 'can_change_radius_on_mapview',
    changeCenter: 'can_change_center_location_on_mapview',
    viewFilters: 'can_view_filters_on_mapview_and_gridview',
    applyFilters: 'can_apply_filters_on_mapview_and_gridview',
    saveData: 'can_save_data_on_mapview_and_gridview',
    addSuppliers: 'can_add_extra_suppliers_on_gridview',
    requestProposal: 'can_request_proposal_on_gridview',
    uploadProposal: 'can_upload_proposal_on_gridview',
    finalizeStatus: 'can_change_supplier_status_to_finalize_on_gridview',
    bufferStatus: 'can_change_supplier_status_to_buffer_on_gridview',
    removeStatus: 'can_change_supplier_status_to_remove_on_gridview',
  },

  opsDashBoard: {
    acceptProposal: 'can_change_proposal_state_to_accept_on_opsdashboard',
    declineProposal: 'can_change_proposal_state_to_decline_on_opsdashboard',
    onHoldPrposal: 'can_change_proposal_state_to_onhold_on_opsdashboard',
  },

  supplierBookingPage: {
    addNegotiatedPrice: 'can_add_negotiated_price_on_supplierbookingpage',
    viewNegotiatedPrice: 'can_view_negotiated_price_on_supplierbookingpage',
    viewBookingStatus: 'can_view_booking_status_of_supplier_on_supplierbookingpage',
    changeBookingStatus: 'can_change_booking_status_of_supplier_on_supplierbookingpage',
    viewPhase: 'can_view_phase_of_supplier_on_supplierbookingpage',
    addPhase: 'can_add_phase_of_supplier_on_supplierbookingpage',
    viewPaymentMode: 'can_view_mode_of_payment_of_supplier_on_supplierbookingpage',
    addPaymentMode: 'can_add_mode_of_payment_of_supplier_on_supplierbookingpage',
    viewPaymentDetails: 'can_view_payment_details_of_supplier_on_supplierbookingpage',
    viewInventoryIds: 'can_view_inventory_ids_of_supplier_on_supplierbookingpage',
    updateData: 'can_update_data_on_supplierbookingpage',
  },

  auditReleasePage: {
    assignDates: 'can_assign_dates_of_campaign_of_all_activities_on_manageauditdetailspage',
    viewDates: 'can_view_dates_of_activities_on_manageauditdetailspage',
    addComments: 'can_add_comments_for_activities_on_manageauditdetailspage',
    updateData: 'can_update_data_on_manageauditdetailspage',
  },

  opsExecutionPage: {
    reAssignDates: 'can_reassign_activity_dates_on_opsexecutionpage',
    viewSupplierDetails: 'can_view_supplier_details_on_opsexecutionpage',
    viewImages: 'can_view_images_on_opsexecutionpage',
    uploadImages: 'can_upload_images_on_opsexecutionpage',
    viewSummary: 'can_view_summary_details_on_opsexecutionpage',
    downloadImages: 'can_download_images_on_opsexecutionpage',
  },

  navBar: {
    viewManagement: 'can_view_management_on_navbar',
    menuHome: 'can_view_homepage_button_on_menu',
    menuOpsDashBoard: 'can_view_opsdashboard_button_on_menu',
    menuCampaignList: 'can_view_campaignlist_button_on_menu',
    menuCampaignLeads: 'can_view_campaignleads_button_on_menu',
    menuDashboard: 'can_view_dashboard_button_on_menu',
    menuChangePassword: 'can_view_changepassword_button_on_menu',
    menuChecklist: 'can_view_checklist_button_on_menu',
    menuLoginLogs: 'login_logs_page_access',
    menuProfileAccount: 'can_view_profile_account',
    menuActivityLogs: 'activity_logs_page_access',
  },
  pagePermissions: {
    homePage: 'homepage_access',
    proposalSummaryPage: 'proposalSummaryPage',
    mapViewPage: 'mapViewPage',
    createProposalPage: 'createProposalPage',
    showCurrentProposalPage: 'showCurrentProposalPage',
    managementPage: 'managementPage',
    opsDashBoardPage: 'ops_dashboard_page_access',
    CampaignListPage: 'CampaignListPage',
    supplierBookingPage: 'supplierBookingPage',
    auditReleasePage: 'auditReleasePage',
    opsExecutionPage: 'opsExecutionPage',
    showProposalHistoryPage: 'showProposalHistoryPage',
    dashboardPage: 'dashboard',
    enter_leads_from_application_access: 'enter_leads_from_application_access',
    editProposalDetailsPage: 'editProposalDetailsPage',
    intervene: 'can_view_intervene',
    templateDashboard: 'can_view_template_dashboard',
    interveneNew: 'can_view_intervene_new',
    templateDashboardNew: 'can_view_template_dashboard_new',
    businessDashboard: 'dashboard_page_access',
    ecommerceDashboard: 'can_view_ecommerce_dashboard',
    webFormPageAccess: 'can_view_web_form',
    b2bFormPageAccess: 'can_view_b2b_form',
    urlGeneratorPageAccess: 'can_view_url_generator_page',
    settingPageAccess: 'can_view_setting_in_sidebar',
    flowBuilderAccess: 'can_view_flow_builder',
    smsDashboardAccess: 'can_view_sms_dashboard',
    campaignListPageAccess: 'campaign_list_page_access',
    campaignLeadsPageAccess: 'campaign_leads_page_access',
    manageSupplierFormAccess: 'manage_supplier_form_access',
    suspenseLeadSheetPageAccess: 'suspense_lead_sheet_page_access',
    dynamicSupplierPageAccess: 'dynamic_supplier_page_access',
    dynamicInventoryPageAccess: 'dynamic_inventory_page_access',
    auditReleasePlanPageAccess: 'audit_release_plan_page_access',
    entityReportPageAccess: 'can_view_entity_report',
    campaignReportPageAccess: 'can_view_campaign_report',
    userPerformancePageAccess: 'can_view_user_performance',
    selfServiceFormsAccess: 'can_view_self_service_form',
    selfServiceDataAccess: 'can_view_self_service_data',
    aiAccess: 'can_view_ai_dashboard',
    vectorDatabaseAccess: 'can_view_vector_database',
    pagesRoutesAccess: 'pages_routes_access',
    clientOnboardingPageAccess: 'can_view_client_onboarding_page',
    benchmarkingAccess: 'can_view_benchmarking_report',
    instructionSet: 'can_view_instruction_set_page',
    setting: 'can_view_setting',
    studentDashboard: 'can_view_student_dashboard',
    parentTeacherDashboard: 'can_view_parent_teacher_dashboard',
  },
  leadDashboard: {
    createWebForm: 'can_create_web_form',
    enterLeadColumn: 'can_view_enter_leads_column',
    importLeadColumn: 'can_view_import_leads_column',
    downloadLeadColumn: 'can_view_download_leads_column',
    mappingLead: 'can_map_leads',
    deleteLeadColumn: 'can_delete_leads',
  },

  dashboard: {
    brandingEmailButton: 'can_view_brandingemailbutton',
  },

  leadFormPage: {
    viewDisposition: 'can_view_disposition',
    assignUnAssignUser: 'can_assign_unassign_user',
    addComment: 'can_add_comment',
    quickCall: 'can_quick_call',
    report: 'can_view_report',
    analytics: 'can_view_analsytics',
    // addDisposition: 'can_add_disposition',
    // editDisposition: 'can_edit_disposition',
  },
  reports: {
    viewReport: 'can_view_report_sidebar',
  },
  performancePermissions: {
    learningIntelligence: 'can_view_learning_intelligence',
    conceptBuilder: 'can_view_concept_builder',
    testCreator: 'can_view_test_creator',
    knowledgeMap: 'can_view_knowledge_map',
    parentDashboard: 'can_view_parent_dashboard',
    teacherDashboard: 'can_view_teacher_dashboard',
    academicInfo: 'can_view_academic_info',
    deleteKnowledgeMap: 'can_delete_knowledge_map',
    questionBank: 'can_view_question_bank',
    classListAccess: 'class_list_access',
  },
  notificationIcon: {
    notificationIcon: 'can_view_notification_icon',
  },
  interveneChat: {
    interveneChat: 'can_view_intervene_chat',
  },
  templateDashboard: {
    editTemplates: 'can_edit_templates',
    deleteTemplates: 'can_delete_templates',
    addTemplates: 'can_add_templates',
    optinUsers: 'can_view_optin_users',
    metaEmbeddedSignup: 'can_view_meta_embedded_signup',
    wabaAppList: 'can_view_waba_app_list',
  },
  machadaloStudioDashboard: {
    machadaloStudioAccess: 'can_view_machadalo_studio',
    presentationBrand: 'can_view_brand',
    instruction_set: 'can_view_instruction_set'
  }
};
